import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { createCategoryPageQueryKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/createCategoryPageQueryKeys";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { useOneIndexedPageNumber } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";

export const useCategoryPageQueryKeys = (pageNumber?: number) => {
  const navigationPath = useCurrentNavigationPath();
  const filterKeys = useCategoryPageFilterKeys();
  const oneIndexedPageNumber = useOneIndexedPageNumber();
  const requestPageNumber = pageNumber ?? oneIndexedPageNumber;
  const requestReferrer = useRequestReferrer();

  return createCategoryPageQueryKeys({
    navigationPath,
    filterKeys,
    oneIndexedPageNumber: requestPageNumber,
    requestReferrer,
  });
};
